<app-tab id="field-report">
  <app-fields-general-report-toolbar (generate)="load($event)"
                                     [request]="request"></app-fields-general-report-toolbar>

  <dx-list
    class="fields-report-summary"
    [dataSource]="summary"
    [grouped]="true"
    [activeStateEnabled]="false"
    [hoverStateEnabled]="false"
    [focusStateEnabled]="false"
    itemTemplate="item"
    width="100%"
    [collapsibleGroups]="true">
    <div *dxTemplate="let intervention of 'item'">
      <div class="p-4">
        <h3 class="font-light border-b border-gray-300 mb-2">Général</h3>
        <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
          <div title="Superficie" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Totale</div>
            <span class="metric-value">{{intervention.field.polygonAreaToHa().toFixed(2)}} <span
              class="metric-unit">Ha</span></span>
          </div>
          <div title="Superficie Travaillée" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Travaillée</div>
            <span class="metric-value">{{intervention.working_area_ha.toFixed(2)}} <span
              class="metric-unit">Ha</span></span>
          </div>
          <div title="Percentage" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Percentage</div>
            <span class="metric-value">{{(intervention.working_area_percent * 100).toFixed(1)}} <span
              class="metric-unit">%</span></span>
          </div>
          <div title="Débit" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Débit</div>
            <span class="metric-value">{{intervention.working_hectare_per_hour.toFixed(2)}} <span
              class="metric-unit">Ha/h</span></span>
          </div>
        </div>
      </div>
      <div class="p-4 pt-0">
        <div class="grid grid-cols-2 gap-3">
          <div>
            <h3 class="font-light border-b border-gray-300 mb-2">Vitesse Travail</h3>
            <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
              <div title="Moyenne" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Moyenne</div>
                <span class="metric-value">{{intervention.working_in_field_speed_avg.toFixed(2)}} <span
                  class="metric-unit">Km/h</span></span>
              </div>
              <div title="Maximale" class="shadow-sm hover:shadow cursor-pointer">
                <div class="metric-text">Maximale</div>
                <span class="metric-value">{{intervention.working_in_field_speed_max.toFixed(2)}} <span
                  class="metric-unit">Km/h</span></span>
              </div>
            </div>
          </div>
          <app-time-pie-chart title="Temps" [data]="timeReports.get(intervention.id)"></app-time-pie-chart>
        </div>
      </div>
    </div>
    <!--<div *dxTemplate="let item of 'group'">
      <div>{{item.key}}</div>
    </div>-->
    <dxo-search-editor-options stylingMode="underlined"></dxo-search-editor-options>
  </dx-list>
</app-tab>


<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '#field-report' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
